1<!--
 * @Description: 系统配置
 * @Author: gao shuai
 * @Date: 2020-03-08 09:26:13
 * @LastEditTime: 2020-05-04 12:04:20
 * @LastEditors: gao shuai
 -->

<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>系统配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="gs_tablestyle">
      <div class="gs_title">商户设置</div>
      <table>
        <tr>
          <td width="150" class="tit">商户注册：</td>
          <td>
            <el-radio-group v-model="register" @change="changeRejister">
              <el-radio :label="1">开启商户注册</el-radio>
              <el-radio :label="2">商户注册审核</el-radio>
              <el-radio :label="0">关闭商户注册</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">微信密保开关：</td>
          <td>
            <el-switch
              v-model="isPlatOpenWxValid"
              @change="changePlatOpenWxValidState"
            ></el-switch>
          </td>
        </tr>
      </table>
    </div>
    <div class="gs_tablestyle mgt15">
      <div class="gs_title">IPS流量统计</div>
      <table>
        <tr>
          <td width="150" class="tit">流量统计开关：</td>
          <td>
            <el-switch v-model="flowSwitch" @change="changeIpState"></el-switch>
          </td>
          <td width="150" class="tit">登陆器统计开关：</td>
          <td>
            <el-switch
              v-model="loginSwith"
              @change="changeLoginState"
            ></el-switch>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">流量统计间隔：</td>
          <td>
            <el-radio-group v-model="flowInterval" @change="changeIptime">
              <el-radio :label="2">2分钟</el-radio>
              <el-radio :label="5">5分钟</el-radio>
              <el-radio :label="10">10分钟</el-radio>
              <el-radio :label="20">20分钟</el-radio>
            </el-radio-group>
          </td>
          <td width="150" class="tit">登陆器统计间隔：</td>
          <td>
            <el-radio-group v-model="loginInterval" @change="changeLogintime">
              <el-radio :label="5">5分钟</el-radio>
              <el-radio :label="10">10分钟</el-radio>
              <el-radio :label="20">20分钟</el-radio>
              <el-radio :label="30">30分钟</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">统计数据清理：</td>
          <td colspan="3">
            <el-button size="small" type="danger" @click="handleClose"
              >清理数据</el-button
            >
            <span class="red"
              >【发布站统计有
              <span style="color: #409eff">{{ loginCount }}</span>
              条记录】★温馨提示：清除数据将保留最近3天统计的数据</span
            >
          </td>
        </tr>
      </table>
    </div>
    <div class="gs_tablestyle1 mgt15">
      <div class="gs_title arrow" @click="show1 = !show1">
        游戏引擎设置<span class="icon" :class="{ on: show1 }"></span>
      </div>
      <el-collapse-transition>
        <div class="addtable" v-show="show1">
          <div class="tabletit"><span>游戏引擎：</span></div>
          <div class="tablebox">
            <table>
              <thead>
                <tr>
                  <th>引擎名称</th>
                  <th>引擎命令</th>
                  <th>扩展指令</th>
                  <th>引擎类别</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in gamedata.list" :key="'game' + i">
                  <td>
                    <el-input
                      size="small"
                      v-model="item.engine"
                      placeholder="请输入引擎名称"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      size="small"
                      v-model="item.command"
                      placeholder="请输入引擎命令"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      size="small"
                      v-model="item.imagecode"
                      placeholder="请输入扩展指令"
                    ></el-input>
                  </td>
                  <td>
                    <el-select
                      v-model="item.type"
                      size="small"
                      placeholder="请选择"
                    >
                      <el-option label="传奇" :value="1"></el-option>
                      <el-option label="传世" :value="2"></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-button size="small" type="danger" @click="deleteGame(i)"
                      >移除引擎</el-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <p class="tc pdt5 pdb5">
              <el-button
                v-if="gamedata.length > gamedata.list.length"
                size="small"
                type="success"
                @click="restoreGame"
                >恢复</el-button
              >
              <el-button size="small" type="primary" @click="addGame"
                >添加</el-button
              >
            </p>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="gs_tablestyle1 mgt15">
      <div class="gs_title arrow" @click="show2 = !show2">
        结算银行卡设置<span class="icon" :class="{ on: show2 }"></span>
      </div>
      <el-collapse-transition>
        <div class="addtable" v-show="show2">
          <div class="tabletit"><span>结算银行卡：</span></div>
          <div class="tablebox">
            <table>
              <thead>
                <tr>
                  <th>银行卡名称</th>
                  <th>银行卡标识</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in bankdata.list" :key="'bank' + i">
                  <td>
                    <el-input
                      size="small"
                      v-model="item.name"
                      placeholder="请输入银行卡名称"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      size="small"
                      v-model="item.mark"
                      placeholder="请输入银行卡标识"
                    ></el-input>
                  </td>
                  <td>
                    <el-button size="small" type="danger" @click="deleteBank(i)"
                      >移除银行</el-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <p class="tc pdt5 pdb5">
              <el-button
                v-if="bankdata.length > bankdata.list.length"
                size="small"
                type="success"
                @click="restoreBank"
                >恢复</el-button
              >
              <el-button size="small" type="primary" @click="addBank"
                >添加</el-button
              >
            </p>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="gs_tablestyle1 mgt15">
      <div class="gs_title arrow" @click="show3 = !show3">
        网站资费标准设置<span class="icon" :class="{ on: show3 }"></span>
      </div>
      <el-collapse-transition>
        <div class="addtable" v-show="show3">
          <div class="tabletit"><span>资费标准：</span></div>
          <div class="tablebox">
            <table>
              <thead>
                <tr>
                  <th>支付类型</th>
                  <th>支持金额</th>
                  <th>商户比例</th>
                  <th>结算周期</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in chargedata.list" :key="'charge' + i">
                  <td>
                    <el-input
                      size="small"
                      v-model="item.type"
                      placeholder="请输入支付类型"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      size="small"
                      v-model="item.des"
                      placeholder="请输入支持金额"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      size="small"
                      v-model="item.rate"
                      placeholder="请输入商户比例"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      size="small"
                      v-model="item.settleType"
                      placeholder="请输入结算周期"
                    ></el-input>
                  </td>
                  <td>
                    <el-button size="small" type="danger" @click="deleteFee(i)"
                      >移除资费</el-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <p class="tc pdt5 pdb5">
              <el-button
                v-if="chargedata.length > chargedata.list.length"
                size="small"
                type="success"
                @click="restoreFee"
                >恢复</el-button
              >
              <el-button size="small" type="primary" @click="addFee"
                >添加</el-button
              >
            </p>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="gs_tablestyle mgt15">
      <div class="gs_title arrow" @click="show4 = !show4">
        网站基本信息<span class="icon" :class="{ on: show4 }"></span>
      </div>
      <el-collapse-transition>
        <div v-show="show4">
          <table>
            <tr>
              <td width="150" class="tit">网站名称：</td>
              <td>
                <el-input
                  size="small"
                  v-model="name"
                  placeholder="请输入内容"
                ></el-input>
              </td>
              <td width="150" class="tit">客服电话：</td>
              <td>
                <el-input
                  size="small"
                  v-model="serverphone"
                  placeholder="请输入内容"
                ></el-input>
              </td>
            </tr>
            <tr>
              <td width="150" class="tit">公司地址：</td>
              <td>
                <el-input
                  size="small"
                  v-model="address"
                  placeholder="请输入内容"
                ></el-input>
              </td>
              <td width="150" class="tit">客服：</td>
              <td>
                <el-tooltip
                  v-for="(item, i) in serverqq"
                  :key="'qq' + i"
                  class="popitem"
                  effect="dark"
                  content="单击可编辑"
                  placement="bottom"
                >
                  <el-tag
                    class="mgr10 mgb5"
                    closable
                    @click="editqq(item, i)"
                    @close="delQQ(i)"
                  >
                    {{ item.name + " : " + item.qq }}
                  </el-tag>
                </el-tooltip>
                <!-- <span class="mgr10 qqspan" v-for="(item,i) in basedata.customerQQ" :key="'qq'+i">{{item.name+' : '+item.qq}}</span> -->
                <el-button
                  size="mini"
                  type="primary"
                  @click="dialogqq.show = true"
                  >新增</el-button
                >
                <!-- <el-input size="small" v-model="serverqq" placeholder="请输入内容"></el-input> -->
              </td>
            </tr>
            <tr>
              <td width="150" class="tit">版权信息：</td>
              <td colspan="3">
                <el-input
                  resize="false"
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="copyright"
                ></el-input>
              </td>
            </tr>
            <tr>
              <td width="150" class="tit">关于我们：</td>
              <td colspan="3">
                <el-input
                  resize="false"
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="aboutme"
                ></el-input>
              </td>
            </tr>
          </table>
        </div>
      </el-collapse-transition>
    </div>
    <div class="gs_tablestyle mgt15">
      <div class="gs_title">结算设置</div>
      <table>
        <tr>
          <td width="150" class="tit">默认结算类型：</td>
          <td>
            <el-radio-group v-model="radio" @change="changeType">
              <el-radio :label="0">T + 0</el-radio>
              <el-radio :label="1">T + 1</el-radio>
            </el-radio-group>
          </td>
          <td width="150" class="tit">默认提现手续费：</td>
          <td>
            <el-input
              size="mini"
              type="number"
              v-model="charge"
              @input="charge = intNumber(charge)"
              placeholder="请输入内容"
            ></el-input>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">T0最小提现金额：</td>
          <td>
            <el-input
              size="small"
              type="number"
              v-model="T0minamout"
              @input="T0minamout = intNumber(T0minamout)"
              placeholder="请输入内容"
            ></el-input>
          </td>
          <td width="150" class="tit">T1最小结算金额：</td>
          <td>
            <el-input
              size="small"
              type="number"
              v-model="T1minamout"
              @input="T1minamout = intNumber(T1minamout)"
              placeholder="请输入内容"
            ></el-input>
          </td>
        </tr>
        <tr>
          <td width="150" class="tit">最小充值金额：</td>
          <td>
            <el-input
              size="small"
              type="number"
              v-model="rechargeMin"
              @input="rechargeMin = intNumber(rechargeMin)"
              placeholder="请输入内容"
            ></el-input>
          </td>
          <td width="150" class="tit">最大充值金额：</td>
          <td>
            <el-input
              size="small"
              type="number"
              v-model="rechargeMax"
              @input="rechargeMax = intNumber(rechargeMax)"
              placeholder="请输入内容"
            ></el-input>
          </td>
        </tr>
      </table>
    </div>
    <p class="mgt20 tc">
      <el-button size="small" type="primary" @click="updateSystem"
        >提交</el-button
      >
    </p>
    <!-- 客服QQ弹框 -->
    <el-dialog
      :title="dialogqq.editflag ? '编辑客服' : '添加客服'"
      :visible.sync="dialogqq.show"
      @close="dialogqqinit"
      custom-class="gs_dialog"
      width="420px"
    >
      <div class="editserverBox">
        <div class="list clearfix">
          <span class="tit">客服类型：</span>
          <div class="content mgt5">
            <el-radio-group v-model="dialogqq.radio">
              <el-radio :label="0">QQ</el-radio>
              <el-radio :label="1">微信</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="list clearfix">
          <span class="tit">客服名称：</span>
          <div class="content">
            <el-input
              size="small"
              v-model="dialogqq.name"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
        <div class="list clearfix">
          <span class="tit">客服号码：</span>
          <div class="content">
            <el-input
              size="small"
              v-model="dialogqq.qq"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
        <div class="list clearfix" v-if="dialogqq.radio === 1">
          <span class="tit">微信二维码：</span>
          <div class="content">
            <el-upload
              class="avatar-uploader"
              accept=".jpg,.jpeg,.png"
              action=""
              :http-request="() => {}"
              :before-upload="fileSelect"
              :show-file-list="false"
            >
              <img
                v-if="dialogqq.imgurl"
                :src="dialogqq.imgurl"
                class="avatar"
              />
              <div v-else class="addbox">
                <i class="el-icon-plus"></i>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <p class="tc pdb10">
        <el-button
          v-if="dialogqq.editflag"
          size="small"
          type="primary"
          @click="editserver"
          >确定</el-button
        >
        <el-button v-else size="small" type="primary" @click="addserver"
          >确定</el-button
        >
        <el-button size="small" type="info" @click="dialogqq.show = false"
          >取消</el-button
        >
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { url } from "../../assets/js/version";
export default {
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      radio: 0, // 默认结算类型
      charge: "", // 默认提现手续费
      register: 1, // 商户注册
      flowSwitch: false, // 流量统计开关
      isPlatOpenWxValid: false,
      loginSwith: false, // 登陆器统计开关
      flowInterval: 2, // 流量统计间隔
      loginInterval: 5, // 登陆器统计间隔
      loginCount: 0, // 登录次数
      gamedata: {
        list: [], // 游戏引擎列表
        backList: "", // 供恢复用的备份
        length: 0, // 数组长度
      },
      bankdata: {
        list: [], // 结算银行卡列表
        backList: "", // 供恢复用的备份
        length: 0, // 数组长度
      },
      chargedata: {
        list: [], // 资费标准列表
        backList: "", // 供恢复用的备份
        length: 0, // 数组长度
      },
      name: "", // 网站名称
      serverphone: "", // 客服电话
      address: "", // 公司地址
      serverqq: [], // 客服qq
      copyright: "", // 版权信息
      aboutme: "", // 关于我们
      T0minamout: "", // T0最小金额
      T1minamout: "", // 最大金额
      rechargeMin: "", // 充值最小金额
      rechargeMax: "", // 充值最大金额
      otherdata: {
        id: "",
        cq3Version: "",
        isOpenTailAmount: true,
        mark: "",
        tailAmountRatio: 0,
        tailAmountScope: 0,
        taskCount: 0,
        timedSettlement: true,
        tyVersion: "",
        version: "",
      },
      dialogqq: {
        editflag: false,
        radio: 0,
        index: 0,
        show: false,
        name: "", // 客服名称
        qq: "", // QQ号码
        imgurl: "",
      },
    };
  },
  methods: {
    // 获取系统设置数据
    getsystemdata() {
      this.$api.systemset
        .getSystemset()
        .then((data) => {
          if (data.status === 200) {
            this.gamedata.list = JSON.parse(data.data.gameEngine);
            this.gamedata.backList = data.data.gameEngine;
            this.gamedata.length = this.gamedata.list.length;
            this.bankdata.list = JSON.parse(data.data.settlementBank);
            this.bankdata.backList = data.data.settlementBank;
            this.bankdata.length = this.bankdata.list.length;
            this.chargedata.list = JSON.parse(data.data.feeStandard);
            this.chargedata.backList = data.data.feeStandard;
            this.chargedata.length = this.chargedata.list.length;
            this.radio = data.data.settlementType;
            this.charge = data.data.defaultFee;
            this.register = data.data.registerState;
            this.flowSwitch = data.data.isIps;
            this.isPlatOpenWxValid = data.data.isPlatOpenWxValid;
            this.loginSwith = data.data.isLogin;
            this.flowInterval = data.data.visitTime;
            this.loginInterval = data.data.loginTime;
            this.name = data.data.webName; // 网站名称
            this.serverphone = data.data.servicePhone; // 客服电话
            this.address = data.data.companyAddress; // 公司地址
            this.serverqq = JSON.parse(data.data.serviceQq); // 客服qq
            this.copyright = data.data.copyRight; // 版权信息
            this.aboutme = data.data.about; // 关于我们
            this.T0minamout = data.data.t0MinAmount; // T0最小金额
            this.T1minamout = data.data.t1MinAmount; // 最大金额
            this.rechargeMin = data.data.rechargeMinAmount; // 充值最小金额
            this.rechargeMax = data.data.rechargeMaxAmount; // 充值最大金额
            this.otherdata.id = data.data.id;
            this.otherdata.cq3Version = data.data.cq3Version;
            this.otherdata.isOpenTailAmount = data.data.isOpenTailAmount;
            this.otherdata.mark = data.data.mark;
            this.otherdata.tailAmountRatio = data.data.tailAmountRatio;
            this.otherdata.tailAmountScope = data.data.tailAmountScope;
            this.otherdata.taskCount = data.data.taskCount;
            this.otherdata.timedSettlement = data.data.timedSettlement;
            this.otherdata.tyVersion = data.data.tyVersion;
            this.otherdata.version = data.data.version;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 获取统计数据
    getSysStatic() {
      this.$api.systemset
        .getSysStatic()
        .then((data) => {
          if (data.status === 200) {
            this.loginCount = data.data;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 清理统计数据
    clearSysStatic() {
      this.$api.systemset
        .clearSysStatic()
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("清理成功！");
            this.getSysStatic();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 清理统计数据提示
    handleClose() {
      this.$confirm("将清除3天以前的所有IPS统计数据,是否清除？")
        .then(() => {
          this.clearSysStatic();
        })
        .catch((_) => {});
    },
    // 移除游戏引擎
    deleteGame(index) {
      this.gamedata.list.splice(index, 1);
    },
    // 恢复游戏引擎
    restoreGame() {
      this.gamedata.list = JSON.parse(this.gamedata.backList);
    },
    // 添加游戏
    addGame() {
      this.gamedata.list.push({
        imagecode:"",
        command: "",
        engine: "",
        type: 1,
      });
    },
    // 移除银行列表
    deleteBank(index) {
      this.bankdata.list.splice(index, 1);
    },
    // 恢复银行列表
    restoreBank() {
      this.bankdata.list = JSON.parse(this.bankdata.backList);
    },
    // 添加银行
    addBank() {
      this.bankdata.list.push({
        mark: "",
        name: "",
      });
    },
    // 移除资费标准
    deleteFee(index) {
      this.chargedata.list.splice(index, 1);
    },
    // 恢复资费标准
    restoreFee() {
      this.chargedata.list = JSON.parse(this.chargedata.backList);
    },
    // 添加资费标准
    addFee() {
      this.chargedata.list.push({
        des: "单笔金额50000以内,大客户洽谈分成！",
        rate: "联系客服",
        settleType: "T0",
        type: "",
      });
    },
    // 系统配置的更新
    updateSystem() {
      this.$api.systemset
        .updateSystem({
          // settlementType: this.radio,
          defaultFee: this.charge === "" ? 0 : parseFloat(this.charge),
          // registerState: this.register,
          // isIps: this.flowSwitch,
          // isLogin: this.loginSwith,
          // visitTime: this.flowInterval,
          // loginTime: this.loginInterval,
          gameEngine: JSON.stringify(this.gamedata.list),
          settlementBank: JSON.stringify(this.bankdata.list),
          feeStandard: JSON.stringify(this.chargedata.list),
          webName: this.name, // 网站名称
          servicePhone: this.serverphone, // 客服电话
          companyAddress: this.address, // 公司地址
          serviceQq: JSON.stringify(this.serverqq), // 客服qq
          copyRight: this.copyright, // 版权信息
          about: this.aboutme, // 关于我们
          t0MinAmount: this.T0minamout === "" ? 0 : parseFloat(this.T0minamout), // T0最小金额
          t1MinAmount: this.T1minamout === "" ? 0 : parseFloat(this.T1minamout), // 最大金额
          rechargeMinAmount:
            this.rechargeMin === "" ? 0 : parseFloat(this.rechargeMin), // 最大金额
          rechargeMaxAmount:
            this.rechargeMax === "" ? 0 : parseFloat(this.rechargeMax), // 最大金额
          // id: this.otherdata.id,
          // cq3Version: this.otherdata.cq3Version,
          // isOpenTailAmount: this.otherdata.isOpenTailAmount,
          // mark: this.otherdata.mark,
          // tailAmountRatio: this.otherdata.tailAmountRatio,
          // tailAmountScope: this.otherdata.tailAmountScope,
          // taskCount: this.otherdata.taskCount,
          // timedSettlement: this.otherdata.timedSettlement,
          // tyVersion: this.otherdata.tyVersion,
          // version: this.otherdata.version
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("更新成功！");
            this.getsystemdata();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 切换结算类型
    changeType() {
      this.$api.systemset
        .changeType({ data: this.radio })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("设置成功！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 切换商户注册状态
    changeRejister() {
      this.$api.systemset
        .changeRejister({ data: this.register })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("设置成功！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 切换流量统计开关状态
    changeIpState() {
      this.$api.systemset
        .changeIpState()
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("设置成功！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    changePlatOpenWxValidState() {
      this.$api.systemset
        .changePlatOpenWxValidState()
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("设置成功！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 切换登录器统计开关状态
    changeLoginState() {
      this.$api.systemset
        .changeLoginState()
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("设置成功！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 切换登录器统计时间间隔
    changeLogintime() {
      this.$api.systemset
        .changeLogintime({ data: this.loginInterval })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("设置成功！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 切换流量统计时间间隔
    changeIptime() {
      this.$api.systemset
        .changeIptime({ data: this.flowInterval })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess("设置成功！");
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 新增客服QQ的弹框初始化
    dialogqqinit() {
      this.dialogqq.editflag = false;
      this.dialogqq.index = 0;
      this.dialogqq.radio = 0;
      this.dialogqq.name = "";
      this.dialogqq.qq = "";
      this.dialogqq.imgurl = "";
    },
    // 新增客服QQ
    addserver() {
      if (this.dialogqq.name === "") {
        this.$messageError("请输入客服名称！");
        return;
      } else if (this.dialogqq.qq === "") {
        this.$messageError("请输入QQ号！");
        return;
      }
      this.serverqq.push({
        name: this.dialogqq.name,
        qq: this.dialogqq.qq,
        type: this.dialogqq.radio,
        imgurl: this.dialogqq.imgurl,
      });
      this.dialogqq.show = false;
    },
    // 编辑客服QQ
    editqq(data, index) {
      this.dialogqq.index = index;
      this.dialogqq.editflag = true;
      this.dialogqq.name = data.name;
      this.dialogqq.qq = data.qq;
      this.dialogqq.radio = data.type;
      this.dialogqq.imgurl = data.imgurl;
      this.dialogqq.show = true;
    },
    // 编辑客服QQ提交
    editserver() {
      if (this.dialogqq.name === "") {
        this.$messageError("请输入客服名称！");
        return;
      } else if (this.dialogqq.qq === "") {
        this.$messageError("请输入QQ号！");
        return;
      }
      this.serverqq.splice(this.dialogqq.index, 1, {
        name: this.dialogqq.name,
        qq: this.dialogqq.qq,
        type: this.dialogqq.radio,
        imgurl: this.dialogqq.imgurl,
      });
      this.dialogqq.show = false;
    },
    // 删除客服qq
    delQQ(index) {
      this.serverqq.splice(index, 1);
    },
    // 图片上传之前的勾子
    fileSelect(file) {
      let form = new FormData();
      form.append("file", file);
      this.$api.systemset
        .uploadWeixin(form)
        .then((data) => {
          this.dialogqq.imgurl = url + data.data;
          this.$messageSuccess("上传成功！");
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
  },
  created() {
    this.getsystemdata();
    this.getSysStatic();
  },
};
</script>

<style lang="scss" scoped>
.gs_tablestyle {
  background: #fff;
  table {
    width: 100%;
    .red {
      color: red;
    }
    td {
      padding: 8px;
      border: 1px solid #e4eaec;
    }
    .tit {
      background: #f1f7f9;
      text-align: center;
    }
  }
}
.gs_tablestyle1 {
  .addtable {
    position: relative;
    padding-left: 135px;
    background: #fff;
    .tabletit {
      position: absolute;
      width: 135px;
      height: 100%;
      left: 0;
      top: 0;
      background: #f1f7f9;
      span {
        position: absolute;
        height: 50px;
        line-height: 50px;
        width: 100%;
        text-align: center;
        top: 50%;
        left: 0;
        margin-top: -25px;
      }
    }
    .tablebox {
      table {
        width: 100%;
        th {
          height: 40px;
          font-size: 14px;
          color: #3e3e3e;
          background: #e4eaec;
          font-weight: normal;
          // border: 1px solid #bfbfbf;
        }
        td {
          height: 50px;
          border: 1px solid #e4eaec;
          text-align: center;
          padding: 0 8px;
        }
      }
    }
  }
}
.popitem {
  cursor: help;
}
.editserverBox {
  padding-left: 20px;
  .list {
    margin-bottom: 10px;
    .tit {
      float: left;
      width: 90px;
      height: 32px;
      line-height: 32px;
    }
    .content {
      float: left;
      width: 250px;
    }
  }
}
.avatar-uploader {
  border: 1px dashed #ccc;
  width: 80px;
  height: 80px;
  border-radius: 8px;
  cursor: pointer;
  img {
    display: block;
    width: 80px;
    height: 80px;
    border-radius: 8px;
  }
  .addbox {
    width: 80px;
    height: 80px;
    text-align: center;
    line-height: 80px;
  }
}
.gs_title {
  &.arrow {
    cursor: pointer;
    .icon {
      float: right;
      height: 30px;
      width: 30px;
      margin-right: 10px;
      margin-top: 5px;
      background: url(../../assets/images/arrow.png) no-repeat right 5px;
      &.on {
        background: url(../../assets/images/arrow.png) no-repeat right -29px;
      }
    }
  }
}
</style>
